export const FETCH_SMS_STEPS_REQUEST = "FETCH_SMS_STEPS_REQUEST";
export const FETCH_SMS_STEPS_SUCCESS = "FETCH_SMS_STEPS_SUCCESS";
export const FETCH_SMS_STEPS_FAILURE = "FETCH_SMS_STEPS_FAILURE";

export const ADD_SMS_STEP_REQUEST = "ADD_SMS_STEP_REQUEST";
export const ADD_SMS_STEP_SUCCESS = "ADD_SMS_STEP_SUCCESS";
export const ADD_SMS_STEP_FAILURE = "ADD_SMS_STEP_FAILURE";

export const UPDATE_SMS_STEP_REQUEST = "UPDATE_SMS_STEP_REQUEST";
export const UPDATE_SMS_STEP_SUCCESS = "UPDATE_SMS_STEP_SUCCESS";
export const UPDATE_SMS_STEP_FAILURE = "UPDATE_SMS_STEP_FAILURE";

export const DELETE_SMS_STEP_REQUEST = "DELETE_SMS_STEP_REQUEST";
export const DELETE_SMS_STEP_SUCCESS = "DELETE_SMS_STEP_SUCCESS";
export const DELETE_SMS_STEP_FAILURE = "DELETE_SMS_STEP_FAILURE";

export const UPDATE_SMS_ORDER_REQUEST = "UPDATE_SMS_ORDER_REQUEST";
export const UPDATE_SMS_ORDER_SUCCESS = "UPDATE_SMS_ORDER_SUCCESS";
export const UPDATE_SMS_ORDER_FAILURE = "UPDATE_SMS_ORDER_FAILURE";
